<template>
  <div id="wish" class="page">
    <div id="foto_container">
      <div id="foto">
        <img src="../assets/img/ben-2018.jpeg">
      </div>
      <div id="kidsname">
          <p>Party</p>
      </div>
    </div>
    <div id="wishinfo">
      <div class="columns">
        <div class="column">
          <p><input placeholder="Datum" name="partydate" v-model="party.partydate"></p>
          <p><input placeholder="Ort" name="partylocation" v-model="party.partylocation"></p>
          <p><input placeholder="Beginn" name="partybegin" v-model="party.beginn"></p>
          <p><input placeholder="Ende" name="partyend" v-model="party.end"></p>
          <p><input placeholder="Telefon" name="mobile" v-model="party.mobile"></p>
          <p><input placeholder="E-Mail" name="email" v-model="party.email"></p>
          
          <div class="actions">
            <p><a @click.prevent="postParty" class="button">
            Party anlegen...
            </a></p>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {db} from '../service/firebase';  
export default {
  name: 'Party',
  components: {
    
  },
  data () {
      return {
        party: {
          'id': null,
          'kid': this.$store.state.kid.id,
          'user': this.$store.state.user.id,
          'partydate':null,
          'partylocation':null,
          'partybegin':null,
          'partyend':null,
          'mobile':this.$store.state.user.mobile,
          'email':this.$store.state.user.email,
          'kidsname':this.$store.state.kid.kidsname,
          'kidscity':this.$store.state.kid.kidscity,
          'messages':[],
          'wishes':[],
          'guests':[]
          }
      }
  },
  methods: {
    postParty() {
      
      //this.$store.user = "Matt"
      
      var ref =  db.ref('/parties').push( this.party )
      this.party.id = ref.key
      this.party.user = this.$store.state.user.id
      
      if(this.party.id) {
        this.$store.state.party = this.party;
        console.log( this.$store );
        this.$router.push('/'+ this.party.id )
      } else {
        console.error('not saved to db!');
      }
      
    }  
  }
}

</script>
<style>
  input { display: block; width: 100%; padding: 0.6333333em 0.7333333em 0.3333333em; line-height: 1; border: 1px solid #ccc; border-radius: 0.3em; }
</style>
